var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.formSubmitted($event)
            },
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "main_details" },
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Raw Material Name",
                        "label-for": "mc-Product-Supplier",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "mc-Product-Supplier",
                          type: "text",
                          readonly: "",
                        },
                        model: {
                          value: _vm.product.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.product, "name", $$v)
                          },
                          expression: "product.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Raw Material Code",
                        "label-for": "mc-Product-Code",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "mc-Product-Code",
                          type: "text",
                          readonly: "",
                        },
                        model: {
                          value: _vm.product.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.product, "code", $$v)
                          },
                          expression: "product.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "mc-stock-threshold",
                        label: "Low Stock Threshold",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-label-group" },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "mc-stock-threshold",
                              type: "text",
                              readonly: "",
                            },
                            model: {
                              value: _vm.product.lowStock,
                              callback: function ($$v) {
                                _vm.$set(_vm.product, "lowStock", $$v)
                              },
                              expression: "product.lowStock",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Total Balance",
                        "label-for": "mc-Balance",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "mc-Balance", type: "text", readonly: "" },
                        model: {
                          value: _vm.totalBalance,
                          callback: function ($$v) {
                            _vm.totalBalance = $$v
                          },
                          expression: "totalBalance",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        attrs: {
          small: "",
          fields: _vm.balanceFields,
          items: _vm.filteredBalances,
          responsive: "sm",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(warehouseId)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.getWarehouseNameById(data.value)) + " "
                ),
              ]
            },
          },
        ]),
      }),
      _c("div", { staticClass: "content-transactions" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-center mb-1" },
          [
            _vm.productLoading ||
            _vm.balanceLoading ||
            _vm.transactionLoading ||
            _vm.warehouseLoading
              ? _c("b-spinner", {
                  staticStyle: { width: "3rem", height: "3rem" },
                  attrs: { variant: "success", label: "Spinning", block: "" },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end my-2" },
              [
                _c("b-button", { on: { click: _vm.exportToCSV } }, [
                  _vm._v("Export to CSV"),
                ]),
              ],
              1
            ),
            _c("b-table", {
              attrs: {
                small: "",
                fields: _vm.transactionFields,
                items: _vm.filteredTransactions,
                responsive: "sm",
              },
              scopedSlots: _vm._u([
                {
                  key: "cell(type)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.getTypeNameById(data.value)) + " "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(date)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dayjs(data.value).format("DD/MM/YYYY hh:mm:ss")
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(fromWarehouse)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.getWarehouseNameById(data.value)) + " "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(toWarehouse)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.getWarehouseNameById(data.value)) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }